module.exports = {
      id: "dot-usage",
      viewBox: "0 0 3 3",
      url: __webpack_public_path__ + "svg-sprite-f0666e191f9085fc3de3ed484b6b7fae.svg#dot",
      toString: function () {
        return this.url;
      }
    }